// Couleur de toute la ligne d'un point dans les listes : règle du V1
// (support-lib.cgi, lignes 1194-1203), reprise telle quelle.
//
//   priorité ≤ 3 → #FFB6BF ; 4-5 → #FAD3B3 ; 6-10 → #CCFCC9 ; au-delà : blanc.
//   Puis l'état écrase la priorité :
//     « Attente validation recette », « Attente validation client »,
//     « Attente informations », « Attente validation temps » → #FFFE9C ;
//     « Finalisé », « A mettre en production » → blanc ;
//     « A mettre en preprod » → #eeeeee ; « Mal qualifié » → #cccccc.
//
// On renvoie une TONALITÉ et non une couleur : index.css porte les couleurs
// exactes du V1 en thème clair et une variante lisible en thème sombre.
export type RowTone = 'prio-haute' | 'prio-moyenne' | 'prio-basse' | 'attente' | 'preprod' | 'mal-qualifie' | null;

/** Hex du V1 en thème clair, pour les tests et la documentation. */
export const V1_ROW_COLORS: Record<Exclude<RowTone, null>, string> = {
  'prio-haute': '#FFB6BF',
  'prio-moyenne': '#FAD3B3',
  'prio-basse': '#CCFCC9',
  attente: '#FFFE9C',
  preprod: '#eeeeee',
  'mal-qualifie': '#cccccc',
};

const ATTENTE = new Set(['Attente validation client', 'Attente informations', 'Attente validation recette', 'Attente validation temps']);

export function rowTone(priorite: number, etat: string): RowTone {
  let tone: RowTone = null;
  if (priorite <= 3) tone = 'prio-haute';
  else if (priorite <= 5) tone = 'prio-moyenne';
  else if (priorite <= 10) tone = 'prio-basse';

  if (ATTENTE.has(etat)) tone = 'attente';
  else if (etat === 'Finalisé' || etat === 'A mettre en production') tone = null;
  else if (etat === 'A mettre en preprod') tone = 'preprod';
  else if (etat === 'Mal qualifié') tone = 'mal-qualifie';
  return tone;
}
